import React, { useState } from 'react';
import useStore from './store';

const ChatWindow = () => {
  const { messages, addMessage, fetchCart } = useStore();
  const [input, setInput] = useState('');

  const handleSendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = { sender: 'user', type: 'text', content: input };
    addMessage(userMessage);
    setInput('');

    try {
      const response = await fetch('/wp-json/chatbot-pro/v1/message', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: input }),
      });

      if (!response.ok) throw new Error('Network response was not ok');

      const aiResponseData = await response.json();
      const aiMessage = { sender: 'ai', ...aiResponseData };
      addMessage(aiMessage);

    } catch (error) {
      const errorMessage = { sender: 'ai', type: 'text', content: 'Sorry, I am having trouble connecting. Please try again later.' };
      addMessage(errorMessage);
    }
  };

  const handleAddToCart = async (productId) => {
    try {
      await fetch('/wp-json/chatbot-pro/v1/add-to-cart', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ product_id: productId, quantity: 1 }),
      });
      fetchCart(); // This function needs to be added to the store
      addMessage({ sender: 'ai', type: 'text', content: 'Product added to your order!' });
    } catch (error) {
      addMessage({ sender: 'ai', type: 'text', content: 'Sorry, there was an error adding the product to your order.' });
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div className="message-history" style={{ flexGrow: 1, overflowY: 'auto', border: '1px solid #eee', padding: '10px', marginBottom: '10px' }}>
        {messages.map((msg, index) => (
          <div key={index} style={{ textAlign: msg.sender === 'user' ? 'right' : 'left', marginBottom: '10px' }}>
            {msg.type === 'text' && (
              <div style={{
                display: 'inline-block',
                padding: '8px 12px',
                borderRadius: '12px',
                backgroundColor: msg.sender === 'user' ? '#007bff' : '#f1f1f1',
                color: msg.sender === 'user' ? 'white' : 'black',
              }}>
                {msg.content}
              </div>
            )}
            {msg.type === 'products' && (
              <div style={{ textAlign: 'left' }}>
                {msg.content.map(product => (
                  <div key={product.id} style={{ border: '1px solid #ddd', borderRadius: '8px', padding: '10px', marginTop: '10px', backgroundColor: 'white' }}>
                    <h4>{product.name}</h4>
                    <p>{product.description}</p>
                    <button onClick={() => handleAddToCart(product.id)} style={{ padding: '8px 12px', border: 'none', backgroundColor: '#28a745', color: 'white', borderRadius: '4px' }}>
                      Add to Cart
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="message-input" style={{ display: 'flex' }}>
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
          placeholder="e.g., 'I need 500 business cards'"
          style={{ flexGrow: 1, padding: '10px', border: '1px solid #ccc', borderRadius: '4px' }}
        />
        <button onClick={handleSendMessage} style={{ padding: '10px 15px', marginLeft: '10px', border: 'none', backgroundColor: '#007bff', color: 'white', borderRadius: '4px' }}>
          Send
        </button>
      </div>
    </div>
  );
};

export default ChatWindow;
